import { useEffect } from "react";
import { useDispatch, useStore } from "react-redux";
import { abandonDepositIntent } from "../../../features/slices/PaymentSlice";
import { clearDepositData } from "../../../features/slices/ModalSlice";

/**
 * Reports the drop-off reason if the deposit flow closes while a deposit
 * intent is still open (i.e. no deposit was submitted), and forgets the
 * method/offer picked in this flow so the next one starts fresh.
 */
export default function useAbandonDepositOnExit() {
  const dispatch = useDispatch();
  const store = useStore();

  useEffect(
    () => () => {
      dispatch(clearDepositData());
      const intent = store.getState().payment.depositIntent;
      if (!intent?.id) return;
      dispatch(
        abandonDepositIntent({
          intentId: intent.id,
          reason: "Deposit screen closed",
          amount: intent.amount,
          paymentMethodId: intent.paymentMethodId,
        })
      );
    },
    []
  );
}
